<template>
  <v-form ref="form">
    <v-card>
      <v-card-title>
        {{ $t("precheckFirstForm.title") }}
      </v-card-title>

      <v-card-text>
        <v-checkbox
          v-model="precheckFirst"
          :label="$t('precheckFirstForm.checkbox.label')"
          :hint="$t('precheckFirstForm.checkbox.hint')"
          persistent-hint
        ></v-checkbox>
      </v-card-text>

      <v-card-actions>
        <v-btn :disabled="!valid" color="primary" class="mr-4" @click="create" :loading="loading">
          {{ $t("precheckFirstForm.save") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
import UpdateUserMutation from "@/gql/mutations/UpdateUserMutation.gql";

export default {
  props: {
    user: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      precheckFirst: !!this.user.precheckFirst,
      loading: false,
    };
  },

  computed: {
    valid() {
      return !!this.user.precheckFirst !== this.precheckFirst;
    },
  },

  methods: {
    async create() {
      this.loading = true;

      await this.$apollo.mutate({
        mutation: UpdateUserMutation,
        variables: {
          id: this.user.id,
          input: {
            precheckFirst: this.precheckFirst,
          },
        },
      });

      this.loading = false;
    },
  },
};
</script>
